var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "url(#paint0_linear_96_173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.865C0 1.2825 1.315 0 2.9375 0H37.0625C38.685 0 40 1.2825 40 2.865V37.135C40 38.7175 38.685 40 37.0625 40H2.9375C1.315 40 0 38.7175 0 37.135V2.865ZM12.3575 33.485V15.4225H6.355V33.485H12.3575ZM9.3575 12.955C11.45 12.955 12.7525 11.57 12.7525 9.835C12.715 8.0625 11.4525 6.715 9.3975 6.715C7.3425 6.715 6 8.065 6 9.835C6 11.57 7.3025 12.955 9.3175 12.955H9.3575ZM21.6275 33.485V23.3975C21.6275 22.8575 21.6675 22.3175 21.8275 21.9325C22.26 20.855 23.2475 19.7375 24.9075 19.7375C27.08 19.7375 27.9475 21.3925 27.9475 23.8225V33.485H33.95V23.125C33.95 17.575 30.99 14.995 27.04 14.995C23.855 14.995 22.4275 16.745 21.6275 17.9775V18.04H21.5875L21.6275 17.9775V15.4225H15.6275C15.7025 17.1175 15.6275 33.485 15.6275 33.485H21.6275Z",
    fill: "#263238"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 2.5,
    stroke: "url(#paint1_linear_96_173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_173",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FFD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_96_173",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FFD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlack);
export default __webpack_public_path__ + "static/media/linkedin-black.4d728eae22af1ce9b61bc2eb2c0733fb.svg";
export { ForwardRef as ReactComponent };